import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";

export default function StoreGrid() {
  const [stores, setStores] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const res = await api.get("/store-offer/store");
        setStores(res.data);
      } catch (error) {
        console.error("Error fetching stores:", error);
      }
    };

    fetchStores();
  }, []);

  return (
    <div className="p-4">
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6">
        {stores.map((store) => (
          <a
            key={store.id}
            // onClick={() => navigate(`/storedetails/${store.storeName}/catalog/${store.id}`)}
             href={`/storedetails/${store.storeName}/catalog/${store.id}`}
            className="border p-4 bg-white cursor-pointer flex items-center justify-center 
                       hover:shadow-md transition group"
          >
            <img
              src={store.logo}
              alt={store.storeName}
              className="w-20 h-20 object-contain transition-transform duration-300 
                         group-hover:-translate-x-2"
            />
          </a>
        ))}
      </div>
    </div>
  );
}
